export default "__VITE_ASSET__DstbRFmc__"